import React, { useMemo, useState } from 'react';
import projects, { PROJECT_GROUPS } from '../../data/projects';
import ProjectCard from './ProjectCard';
import FilterBar from './FilterBar';
import styles from './Projects.module.css';

export default function ProjectSection() {
  const [active, setActive] = useState(null); // null === "All"

  const filters = useMemo(
    () => [
      { id: null, label: 'All', count: projects.length },
      ...PROJECT_GROUPS.map((g) => ({
        id: g.id,
        label: g.label,
        count: projects.filter((p) => p.group === g.id).length,
      })),
    ],
    []
  );

  // "All" keeps the three labelled bands; a single filter flattens to one grid.
  const bands = active
    ? PROJECT_GROUPS.filter((g) => g.id === active)
    : PROJECT_GROUPS;

  return (
    <section className={styles.section} id="projects" aria-labelledby="projects-heading">
      <header className={styles.header}>
        <p className="mc-eyebrow">02 / Selected Work</p>
        <h2 id="projects-heading" className={styles.heading}>Projects</h2>
        <p className={styles.lede}>
          Competition robots, hardware hacks and things I built because I wanted them to exist.
        </p>
      </header>

      <FilterBar filters={filters} active={active} onChange={setActive} />

      {bands.map((group) => {
        const items = projects.filter((p) => p.group === group.id);
        if (!items.length) return null;
        return (
          <div key={group.id} className={styles.band}>
            <div className={styles.bandHead}>
              <h3 className={styles.bandTitle}>
                {group.label}
                <span className={styles.bandCount}>{String(items.length).padStart(2, '0')}</span>
              </h3>
              <p className={styles.bandBlurb}>{group.blurb}</p>
            </div>
            <ul className={styles.grid}>
              {items.map((p) => <ProjectCard key={p.id} project={p} />)}
            </ul>
          </div>
        );
      })}
    </section>
  );
}
